function customerOrdersFilter() {
  const node = document.querySelector("[data-filer-orders]");
  if (node) {
    node.off("change.filter-orders");
    node.on("change.filter-orders", (evt) => {
      const value = evt.target.value;
      const tableRows = document.querySelectorAll(".table__section");
      if (tableRows) {
        if (!value) {
          tableRows.forEach((row) => {
            row.classList.remove("hide");
          });
        } else {
          tableRows.forEach((row) => {
            const nodeTag = row.querySelector(".tag");
            if (!nodeTag) {
              return;
            }
            if (!nodeTag.innerText.includes(value)) {
              row.classList.add("hide");
            } else {
              row.classList.remove("hide");
            }
          });
        }
      }
    });
  }
}

function remove_item(key) {
  event.preventDefault();
  var data = {
    quantity: 0,
    id: key
  }

  fetch(theme.routes.cartChange, {
    method: "POST",
    body: JSON.stringify(data),
    credentials: "same-origin",
    headers: {
        "Content-Type": "application/json"
    }
  }).then(e => e.json()).then(function(e) {
  if (422 === e.status || "bad_request" === e.status)
  ;
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
  .bind(this));
}

function remove_overlay() {
  document.querySelector('body').classList.remove('predictive-overflow-hidden');
}
